import { Playground } from "docz";
import { Translator, DynamicText } from "../../../../../docz/components";
import React from 'react';
export default {
  Playground,
  Translator,
  DynamicText,
  React
};